import { createSelector } from 'reselect';
import { statusOptions } from './ElectronicEquipmentForm';

// Base selectors
const selectEquipmentTypes = (state) => state.electronicEquipment?.equipmentTypes || [];
const selectEquipment = (state) => state.electronicEquipment?.equipment || [];
const selectStationsList = (state) => state.companies?.stationsList || [];

// Memoized selector for table data
export const selectElectronicEquipmentTableData = createSelector(
  [selectEquipment, selectEquipmentTypes, selectStationsList],
  (equipment, equipmentTypes, stationsList) => {
    return equipment.map((data) => {
      const equipmentType = equipmentTypes.find((item) => item.id === data.idEquipmentType);
      const equipmentStation = stationsList.find((item) => item.id === data.idStation);
      const equipmentStatus = statusOptions.find((item) => item.value === data.status);

      return {
        ...data,
        equipmentTypeName: equipmentType?.name,
        stationName: equipmentStation?.name,
        statusLabel: equipmentStatus?.label,
      };
    });
  }
);